(() => {
  const popup = document.getElementById('pmweb-popup-demo');
  if (!popup || popup.dataset.initialized || typeof popup.showModal !== 'function') return;
  popup.dataset.initialized = 'true';
  const key = 'pmweb-popup-20261201-seen';
  const preview = new URLSearchParams(location.search).get('pmweb_popup') === 'preview' || Boolean(window.Shopify && Shopify.designMode);
  const deadline = Date.parse(popup.dataset.deadline);
  let tick;
  let previousOverflow = '';
  let focusBeforeOpen;
  let scheduled;
  let pageLocked = false;
  function seen() {
    try { return sessionStorage.getItem(key) === '1'; } catch { return false; }
  }
  function markSeen() {
    try { sessionStorage.setItem(key, '1'); } catch {}
  }
  function measure(action, destination) {
    const privacy = window.Shopify && Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event:'pmweb_popup_'+action, popup_id:'pmweb_launch_20261201', ...(destination ? {destination} : {})});
  }
  function updateCountdown() {
    const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    const values = {days:Math.floor(remaining/86400), hours:Math.floor(remaining%86400/3600), minutes:Math.floor(remaining%3600/60), seconds:remaining%60};
    for (const [name,value] of Object.entries(values)) popup.querySelector('[data-time="'+name+'"]').textContent = String(value).padStart(2,'0');
    const expired = remaining === 0 || !Number.isFinite(deadline);
    popup.querySelector('.pw-launch-pricing').hidden = expired;
    popup.querySelector('.pw-timer').hidden = expired;
    popup.querySelector('.pw-launch-currency').hidden = expired;
    popup.querySelector('.pw-expired').hidden = !expired;
    if (expired && tick) clearInterval(tick);
  }
  function restorePage() {
    if (!pageLocked) return;
    pageLocked = false;
    document.body.style.overflow = previousOverflow;
    if (tick) clearInterval(tick);
    if (focusBeforeOpen && focusBeforeOpen.isConnected && typeof focusBeforeOpen.focus === 'function') focusBeforeOpen.focus({preventScroll:true});
  }
  function dismiss(reason) {
    if (!popup.open) return;
    markSeen();
    measure('dismiss',reason);
    popup.close();
    restorePage();
  }
  function open() {
    if (!popup.isConnected || popup.open || (!preview && seen())) return;
    if (document.hidden) {
      document.addEventListener('visibilitychange',function visible() {
        if (!document.hidden) {document.removeEventListener('visibilitychange',visible);open();}
      });
      return;
    }
    if (document.querySelector('dialog[open]')) {scheduled=setTimeout(open,1000);return;}
    const stylesheet=document.querySelector('[data-pw-popup-styles]');
    if (stylesheet && !stylesheet.sheet) {scheduled=setTimeout(open,100);return;}
    updateCountdown();
    focusBeforeOpen=document.activeElement;
    previousOverflow=document.body.style.overflow;
    popup.showModal();
    document.body.style.overflow='hidden';
    pageLocked=true;
    markSeen();
    measure('view');
    if (Date.now()<deadline) tick=setInterval(updateCountdown,1000);
  }
  popup.querySelectorAll('[data-pw-close]').forEach(button=>button.addEventListener('click',()=>dismiss('close')));
  popup.querySelectorAll('[data-pw-destination]').forEach(link=>link.addEventListener('click',()=>{
    markSeen();
    measure('click',link.dataset.pwDestination);
    popup.close();
    restorePage();
  }));
  popup.addEventListener('cancel',event=>{event.preventDefault();dismiss('escape');});
  popup.addEventListener('close',restorePage);
  popup.addEventListener('click',event=>{
    if (event.target !== popup) return;
    const rect=popup.getBoundingClientRect();
    if(event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom) dismiss('backdrop');
  });
  function start() {
    if (!preview && seen()) return;
    scheduled=setTimeout(open,Number(popup.dataset.delay)||5000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
  window.addEventListener('pagehide',()=>{clearTimeout(scheduled);if(tick)clearInterval(tick);},{once:true});
})();
